// environment.dev.ts

export const environment = {
  tagName: 'Development',
  production: false,
  apiUrl: 'https://api.ai-author-beta.learmo.dev/api/v1',
};
